(function () {
    'use strict';

    /**
     * @ngdoc factory
     * @name fuel.factory:FuelRequestFactory
     *
     * @description
     *
     */
    angular
        .module('fuel')
        .factory('FuelRequestFactory', FuelRequestFactory);
    function FuelRequestFactory() {

        function SearchCriteriaDTO(){
            this.companyName = null;
            this.companyAbbr = null;
            this.cities = [];
            this.status = null;
        }
        function SupplierDTO() {
            this.fuelSupplierId = null;
            this.version = null;
            this.companyName = null;
            this.companyAbbr = null;
            this.contactData = null;
            this.address = null;
            this.city = null;
            this.status = true;
        }
        function SaveFuelPriceRequest() {
            // mandatory fields
            this.currency = null;
            this.currencyRatePerUSD = null;
            this.fuelPricePerMTonInUSD = null;
            this.fromDate = null;
            this.toDate = null;
            this.airportCode = null;
            this.fuelSupplierId = null;
            this.remarks = null;

            // others
            this.version = null;
            this.fuelPriceId = null;
            this.createdDate = null;
            this.createdTime = null;
            this.createdBy = null;
            this.gstPercentage = null;
        }

        function FuelPriceSearchDTO() {
            this.airportCode = null;
            this.pageSize=null;
            this.startPosition=null;
        }

        function DeleteFuelPriceRequest() {
            this.fuelPriceId = null;
            this.version = null;
        }

        function DeleteFlightFuelInfoRequest() {
            this.fuelSupplierId = null;
            this.version = null;
        }
        function FuelUpliftRequest(){
        	this.receipt = null;
        	this.airports = [];
        	this.fromDate = null;
        	this.toDate = null;
        	this.haj = false;
        }
        function GetFormattedFuelSuppliersSearchRequest(params) {
            var formattedCriteria =  new SearchCriteriaDTO();
            if(!!params.city && !!params.city.airPortCode){
                formattedCriteria.cities.push(params.city.airPortCode);
            }
            formattedCriteria.companyName = params.companyName;
            formattedCriteria.companyAbbr = params.companyAbbr;
            formattedCriteria.status = params.status===null?null:params.status.value;
            return formattedCriteria;
        }

       function GetFormattedFuelUpliftSearchRequest(params){
    	   var formattedCriteria =  new FuelUpliftRequest();
    	   if(params.receipt!== null && params.receipt !== ""){
    		   formattedCriteria.receipt = params.receipt;
    	   }
    	   if(params.fromDate!== null && params.fromDate !== ""){
    		   formattedCriteria.fromDate = params.fromDate;
    	   }
    	   if(params.toDate!== null && params.toDate !== ""){
    		   formattedCriteria.toDate = params.toDate;
    	   }
    	   formattedCriteria.haj = params.haj;
    	   angular.forEach(params.airports, function (obj) {
    		   if(obj!== " "){
    			   formattedCriteria.airports.push(obj.airPortCode);
    		   }
           });
    	   return formattedCriteria;
       }

        function GetFuelSuppliersSearchRequest() {
            return new SearchCriteriaDTO();
        }
        function GetFuelUpliftSearchRequest(){
        	return new FuelUpliftRequest()
        }

        function GetFormattedSuppliers(suppliers) {
            var formattedList = [];
            angular.forEach(suppliers, function (supplier, key) {
                formattedList.push(formatSupplier(supplier))
            });
            return formattedList;
        }

        function formatSupplier(sup) {
            var newSup = new SupplierDTO();
            //TODO do formatting required
            newSup = sup;
            return newSup;
        }

        function GetSupplierForEditor() {
            return new SupplierDTO();
        }
        function GetSupplierForDelete(supplier) {
            var deleteRq = new DeleteFlightFuelInfoRequest();
            deleteRq.fuelSupplierId = supplier.fuelSupplierId;
            deleteRq.version = supplier.version;
            return deleteRq;
        }
        function GetSupplierForSave(supplier) {
            var newSupplier = new SupplierDTO();
            newSupplier.city = supplier.city.airPortCode;
            newSupplier.companyAbbr = supplier.companyAbbr;
            newSupplier.companyName = supplier.companyName;
            newSupplier.fuelSupplierId = supplier.fuelSupplierId;
            newSupplier.contactData = supplier.contactData;
            newSupplier.address = supplier.address;
            newSupplier.status = supplier.status?"INA":"ACT";
            newSupplier.version = supplier.version===null?0:supplier.version;
            return newSupplier;
        }

        function GetFuelPriceForSave(price) {
            var newPrice = new SaveFuelPriceRequest();
            newPrice.airportCode = price.airportCode && price.airportCode.airPortCode;
            newPrice.fromDate = price.fromDate;
            newPrice.toDate = price.toDate;
            newPrice.currencyRatePerUSD = price.currencyRatePerUSD;
            newPrice.fuelPricePerMTonInUSD = price.fuelPricePerMTonInUSD;
            newPrice.currency = null;
            newPrice.fuelPriceId = price.fuelPriceId;
            newPrice.fuelSupplierId = price.fuelSupplierId && price.fuelSupplierId.fuelSupplierId;
            newPrice.remarks = price.remarks;
            newPrice.gstPercentage = price.gstPercentage;
            newPrice.version = price.version;
            newPrice.createdBy = price.createdDate;
            newPrice.createdTime = price.createdTime;
            newPrice.createdDate = price.createdDate;
            return newPrice;
        }
        function GetFuelPriceSearchCriteria() {
            return new FuelPriceSearchDTO();
        }

        function GetFuelPriceSaveReq() {
            return new SaveFuelPriceRequest();
        }

        function GetFuelPriceDeleteReq(price) {
            var new_price = new DeleteFuelPriceRequest();
            new_price.fuelPriceId = price.fuelPriceId;
            new_price.version = price.version;
            return new_price;
        }
        function GetFormattedFuelPrices(prices, suppliers) {
            var formattedList = [];
            angular.forEach(prices, function (price) {
                formattedList.push(formatFuelPrice(price, suppliers))
            });
            return formattedList;
        }
        function formatFuelPrice(price, suppliers) {
            var newPrice = new SaveFuelPriceRequest();
            newPrice.airportCode = price.airportcode;
            newPrice.fromDate = price.fromDate;
            newPrice.toDate = price.toDate;
            newPrice.currencyRatePerUSD = price.currencyRatePerUSD;
            newPrice.fuelPricePerMTonInUSD = price.fuelPricePerMTonInUSD;
            newPrice.currency = null;
            newPrice.fuelSupplierId = price.fuelSupplierId;
            newPrice.remarks = price.remarks;
            newPrice.gstPercentage = price.gstPercentage;
            newPrice.version = price.version;
            newPrice.fuelPriceId = price.priceId;
            newPrice.createdBy = price.createdDate;
            newPrice.createdTime = price.createdTime;
            newPrice.createdDate = price.createdDate;
            var supplier = _.find(suppliers, {'fuelSupplierId':price.fuelSupplierId});
            if(supplier && supplier.hasOwnProperty('title')){
                newPrice.supplier= supplier;
            }
            return newPrice;
        }
        return {
            getFuelSuppliersSearchRequest: GetFuelSuppliersSearchRequest,
            getFormattedFuelSuppliersSearchRequest: GetFormattedFuelSuppliersSearchRequest,
            getFormattedSuppliers:GetFormattedSuppliers,
            getSupplierForEditor: GetSupplierForEditor,
            getSupplierForDelete: GetSupplierForDelete,
            getSupplierForSave: GetSupplierForSave,
            getFuelPriceSearchCriteria: GetFuelPriceSearchCriteria,
            getFormattedPrices: GetFormattedFuelPrices,
            getFuelPriceSaveReq: GetFuelPriceSaveReq,
            getFuelPriceDeleteReq: GetFuelPriceDeleteReq,
            getFuelPriceForSave: GetFuelPriceForSave,
            getFuelUpliftSearchRequest : GetFuelUpliftSearchRequest,
            getFormattedFuelUpliftSearchRequest : GetFormattedFuelUpliftSearchRequest
        }
    }
})();
